import { ref } from 'vue';

import { useUserStore } from '../store/user';
import { useCalculatorsStore } from '../store/calculators';
import { useClientsStore } from '../store/clients';
import { useCalculationsStore } from '../store/calculations';
import { usePricesStore } from '../store/prices';
import { useProductsStore } from '../store/products';
import { useRulesStore } from '../store/rules';
import { useItemsStore } from '../store/items';
import { useGrantsStore } from '../store/grants';

export function useOfflineData() {
  const isDone = ref(false);

  const isLoading = ref(false);

  const userStore = useUserStore();
  const calculatorsStore = useCalculatorsStore();
  const clientsStore = useClientsStore();
  const calcultionsStore = useCalculationsStore();
  const pricesStore = usePricesStore();
  const productsStore = useProductsStore();
  const rulesStore = useRulesStore();
  const itemsStore = useItemsStore();
  const grantsStore = useGrantsStore();

  async function fetchAllData() {
    try {
      isLoading.value = true;

      await Promise.all([
        userStore.fetchUser(),
        calculatorsStore.fetchCalculators(),
        clientsStore.fetch(),
        calcultionsStore.fetch(),
        pricesStore.fetch(),
        productsStore.fetch(),
        rulesStore.fetch(),
        itemsStore.fetch(),
        grantsStore.fetch(),
      ]);
    } catch (error) {
      console.log(error);

      throw error;
    } finally {
      isLoading.value = false;
      isDone.value = true;
    }
  }

  function invalidateAllData() {
    userStore.user = null;
    calculatorsStore.data = null;
    clientsStore.data = null;
    pricesStore.data = null;
    productsStore.data = null;
    rulesStore.data = null;
    itemsStore.data = null;
    calcultionsStore.data = null;
    grantsStore.data = null;
  }

  function invalidateSomeData() {
    userStore.user = null;
    calculatorsStore.data = null;
    pricesStore.data = null;
    productsStore.data = null;
    rulesStore.data = null;
    itemsStore.data = null;
    grantsStore.data = null;
  }

  return {
    isLoading,
    isDone,
    fetchAllData,
    invalidateAllData,
    invalidateSomeData,
  };
}
